import { getRelativePath } from 'base/shared/Utils';

export const getResetPasswordPath = () => {
  return getRelativePath('/reset');
};
